export const mapDevicesToUser = (
	availableDevices: MediaDeviceInfo[],
	camera?: MediaDeviceInfo,
	mic?: MediaDeviceInfo
) =>
	availableDevices.map((device: MediaDeviceInfo) => ({
		id: device.deviceId,
		name: device.label,
		type: device.kind,
		selected:
			device.deviceId === camera?.deviceId || device.deviceId === mic?.deviceId,
	}));
